<template>
  <div class="dft-d-container" :style="container_Style">
    <div class="dft-itnav_box" :style="itnav_box_Style">
      <div class="dft-itnav_item" :style="itnav_item_style" v-for="(item,index) in imgtextNav" :key="index">
        <div class="dft-itnav_image" v-if="model != '3'" :style="itnav_image_style">
          <!-- uniapp -->
          <el-image class="img_class" :src="item.logo" fit="cover"></el-image>
        </div>
        <div class="dft-itnav_text" :style="itnav_text_style">
          {{item.categoryName}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    compData: {
        type: [Array,Object],
        default: ()=>[]
    },
  },
		options: {
			styleIsolation: 'shared', // 解除样式隔离
		},
  data () {
    return {
      showDialog: false,
    };
  },
  watch:{
    compData: {
      handler: function(newVal){
        if(newVal){
          this.$nextTick(() => {
            // console.log('comp--D-ata--0',newVal)
          });
        }
      },
      deep: true,
      immediate: true,
    }
  },
  computed: {
    //数据
    imgtextNav(){
      return this.compData?.attr?.a1?.value
    },
    model(){
      return this.compData?.attr?.a2?.value
    },
    listclass(){
      return this.compData?.attr?.a3?.value
    },
    // 样式
    container_Style(){
      return {
        'padding': `${this.compData?.attr?.['a7']?.value} ${this.compData?.attr?.['a8']?.value}px`,
      }
    },
    itnav_box_Style(){
      switch(this.listclass){
        case '1':
          return {
            'background': this.compData?.attr?.['a4']?.value,
            'color': this.compData?.attr?.['a5']?.value,
            'border-radius': this.compData?.attr?.['a6']?.value,
            'display': 'grid',
            'grid-template-columns': this.imgtextNav?.length>5?`repeat(5, 1fr)`:`repeat(${this.imgtextNav?.length}, 1fr)`
          }
        case '2':
          return {
            'background': this.compData?.attr?.['a4']?.value,
            'color': this.compData?.attr?.['a5']?.value,
            'border-radius': this.compData?.attr?.['a6']?.value,
            'display': 'flex',
            'flex-shrink': '0',
            'margin': '0 4px',
            'align-items': 'center',
            'overflow-x': 'auto',
          }
        default:
          return {}
      }
    },
    itnav_item_style(){
      switch (this.listclass) {
        case '2':
          return {
            'min-width': '80px',
            'height': this.model == '3'?'42px':'86px',
          }
        default:
          return {
            'height': this.model == '3'?'50px':'86px',
            'overflow': 'hidden',
          }
      }
    },
    itnav_image_style(){
      return {
        'width': `${this.compData?.attr?.['a10']?.value}px`,
        'height': `${this.compData?.attr?.['a10']?.value}px`,
        'border-radius': `${this.compData?.attr?.['a11']?.value == 1?'unset':'50%'}`,
      }
    },
    itnav_text_style(){
      return {
        'font-size': `${this.compData?.attr?.['a9']?.value}px`,
      }
    },
  },
  created () {
  },

  mounted () {
    this.$nextTick(() => {
    })
  },

  methods: {
    initData(){
    },
  },
};
</script>

<style lang="scss" scoped>
.dft-d-container{
  width: 100%;
  height: auto;
  padding: 0;
  box-sizing: border-box;
}
.dft-itnav_box{
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  // display: flex;
  // flex-wrap: wrap;
  // align-items: center;
  // display: grid;
  font-size: 14px;
  &::-webkit-scrollbar {
    height: 0px;
  }
}
.dft-itnav_item{
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}
.dft-itnav_image{
  width: 60px;
  height: 60px;
  margin-bottom: 4px;
  flex-shrink: 0;
  overflow: hidden;
}
.dft-itnav_text{
  display: flex;
  display: -webkit-box;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 24px;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.img_class{
  display: block;
  width: 100%;
  height: 100%;
}
</style>

